import { axios } from '@/services/axios';

export const createTrunkType = (trunkTypeData) => {
    return axios.post('/trunktype', trunkTypeData);
};
